import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "27px",
    height: "100%",
    width: "100%",
    lineHeight: "1.7",
  },
  landscapeArrowContainer: {
    fontSize: "6px",
    color: "#FF0000",
    width: "30px",
    alignSelf: "flex-end",
  },
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    width: "100%",
    height: "100%",
    lineHeight: "1.7",
  },
  portraitContainer: {
    flexDirection: "column",
  },
  portraitLeftSection: {
    flexDirection: "column",
    width: "45%",
    height: "100%",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
    alignSelf: "flex-end",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument31 = ({ arabChunks, engChunks }) => {
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  return (
    <Document>
      <Page size="A5" orientation="landscape" style={Styles.landscapePage}>
        <View style={{ flexDirection: "row", textAlign: "right" }}>
          <View style={{ width: "30px" }}></View>
          <View style={{ flexDirection: "column", width: "88%" }}>
            <View style={{ height: "30px" }}>
              <View
                style={[
                  Styles.landscapeArrowContainer,
                  { transform: "rotate(-90deg)", width: "25px" },
                ]}
              >
                <Text
                  style={[
                    Styles.pointingText,
                    { width: "30px", marginLeft: "-4px" },
                  ]}
                >
                  بداية النص
                </Text>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-start" }]}
                ></Image>
              </View>
            </View>
            <View style={{ height: "296px", overflow: "hidden" }}>
              <View
                style={[
                  {
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[0])}
              </View>
            </View>
            <View style={{ height: "30px" }}></View>
          </View>
          <View style={{ width: "30px" }}></View>
        </View>
      </Page>

      <Page size="A4" style={Styles.portraitPage}>
        <View style={Styles.portraitContainer}>
          <View style={{ margin: "27px" }}>
            <View style={{ flexDirection: "row", textAlign: "right" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[Styles.arrowIcon, { transform: "rotate(-90deg)" }]}
                  ></Image>
                </View>
                <View style={{ height: "296px", overflow: "hidden" }}>
                  <View
                    style={[
                      {
                        textAlign: "right",
                      },
                    ]}
                  >
                    {arabicText(arabChunks[1])}
                  </View>
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
          <View style={{ margin: "27px" }}>
            <View style={{ flexDirection: "row", textAlign: "right" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View style={{ height: "30px" }}>
                  <View
                    style={[
                      Styles.landscapeArrowContainer,
                      {
                        alignSelf: "flex-start",
                        transform: "rotate(90deg)",
                        width: "32px",
                      },
                    ]}
                  >
                    <Text
                      style={[
                        Styles.pointingText,
                        {
                          marginBottom: "6px",
                          marginLeft: "-8px",
                          width: "40px",
                        },
                      ]}
                    >
                      Start of text
                    </Text>
                    <Image
                      src="/images/rightpdf_arrow.png"
                      style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
                    ></Image>
                  </View>
                </View>
                <View
                  style={{
                    height: "296px",
                    overflow: "hidden",
                    textAlign: "left",
                  }}
                >
                  {engChunks[0]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.portraitPage}>
        <View style={Styles.portraitContainer}>
          <View style={{ margin: "27px" }}>
            <View style={{ flexDirection: "row", textAlign: "right" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[
                      Styles.arrowIcon,
                      { transform: "rotate(-90deg)", alignSelf: "flex-start" },
                    ]}
                  ></Image>
                </View>
                <View
                  style={{
                    height: "296px",
                    overflow: "hidden",
                    textAlign: "left",
                  }}
                >
                  {engChunks[1]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
          <View style={{ margin: "27px" }}>
            <View style={{ flexDirection: "row", textAlign: "right" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[
                      Styles.arrowIcon,
                      { alignSelf: "flex-start", transform: "rotate(-90deg)" },
                    ]}
                  ></Image>
                </View>

                <View
                  style={{
                    height: "296px",
                    overflow: "hidden",
                    textAlign: "left",
                  }}
                >
                  {engChunks[2]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A4" style={Styles.portraitPage}>
        <View style={Styles.portraitContainer}>
          <View style={{ margin: "27px" }}>
            <View style={{ flexDirection: "row", textAlign: "right" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[
                      Styles.arrowIcon,
                      { transform: "rotate(-90deg)", alignSelf: "flex-start" },
                    ]}
                  ></Image>
                </View>
                <View
                  style={{
                    height: "296px",
                    overflow: "hidden",
                    textAlign: "left",
                  }}
                >
                  {engChunks[3]?.map((word, idx) => {
                    return (
                      <Text style={{}} key={idx}>
                        {word}
                      </Text>
                    );
                  })}
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={[Styles.landscapeArrowContainer, { width: "30px" }]}>
                <Text
                  style={[
                    Styles.pointingText,
                    { width: "40px", marginLeft: "-6px" },
                  ]}
                >
                  End of Text
                </Text>
                <Image
                  src="/images/leftpdf_arrow.png"
                  style={[Styles.arrowIcon, { alignSelf: "flex-start" }]}
                ></Image>
              </View>
            </View>
          </View>
          <View style={{ margin: "27px" }}>
            <View style={{ flexDirection: "row", textAlign: "right" }}>
              <View style={{ width: "30px" }}></View>
              <View style={{ flexDirection: "column", width: "88%" }}>
                <View
                  style={{
                    height: "30px",
                    justifyContent: "flex-end",
                    marginBottom: "6px",
                  }}
                >
                  <Image
                    src="/images/leftpdf_arrow.png"
                    style={[Styles.arrowIcon, { transform: "rotate(-90deg)" }]}
                  ></Image>
                </View>
                <View
                  style={{
                    height: "296px",
                    overflow: "hidden",
                  }}
                >
                  <View
                    style={[
                      {
                        textAlign: "right",
                      },
                    ]}
                  >
                    {arabicText(arabChunks[2])}
                  </View>
                </View>
                <View style={{ height: "30px" }}></View>
              </View>
              <View style={{ width: "30px" }}></View>
            </View>
          </View>
        </View>
      </Page>

      <Page size="A5" orientation="landscape" style={Styles.landscapePage}>
        <View style={{ flexDirection: "row", textAlign: "right" }}>
          <View style={{ width: "30px" }}>
            <View
              style={[
                Styles.landscapeArrowContainer,
                { position: "absolute", top: "90%" },
              ]}
            >
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/rightpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
          <View style={{ flexDirection: "column", width: "88%" }}>
            <View
              style={{
                height: "30px",
                justifyContent: "flex-end",
                marginBottom: "6px",
              }}
            >
              <Image
                src="/images/leftpdf_arrow.png"
                style={[Styles.arrowIcon, { transform: "rotate(-90deg)" }]}
              ></Image>
            </View>
            <View style={{ height: "296px", overflow: "hidden" }}>
              <View
                style={[
                  {
                    textAlign: "right",
                  },
                ]}
              >
                {arabicText(arabChunks[3])}
              </View>
            </View>
            <View style={{ height: "30px" }}></View>
          </View>
          <View style={{ width: "30px" }}></View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument31;
